import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import axios from "axios";
import discount from "../assets/images/discount.svg";
import verified from "../assets/images/verified.svg";
import blue_star from "../assets/images/blue_star.svg";
import config from "../config/config";
import default_user from "../assets/images/default_user.webp";
import subscriptions_user from "../assets/images/Subscriptionsblue.png";
import like_notification from "../assets/images/heart_icon_fill.svg";
import TipNotification from "../assets/images/TipNotification.svg";
import CommentLikeNotification from "../assets/images/CommentLikeNotification.svg";
import PostMentionNotification from "../assets/images/PostMentionNotification.svg";
import PostPurchasedNotification from "../assets/images/PostPurchasedNotification.svg";
import loaderIcon from '../assets/images/loader.gif';
import CollectionUserListNotification from './CollectionUserListNotification';
import CollectionCreateListNotification from './CollectionCreateListNotification';

const PillsPostNotification = () => {
  const [notifications, setNotifications] = useState([]);
  const [showSaveToListModal, setShowSaveToListModal] = useState({
    visible: false,
    userId: null,
  });
  const [userLists, setUserLists] = useState([]);
  const [checkedLists, setCheckedLists] = useState(new Set());
  const [showCreateListModal, setShowCreateListModal] = useState(false);
  const [listName, setListName] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [apiResponseMessage, setApiResponseMessage] = useState("");
  const [wordCount, setWordCount] = useState(0);
  const [loading, setLoading] = useState(true);
  const { username } = useParams();
  
useEffect(() => {
  const fetchNotifications = async () => {
    try {
      const token = localStorage.getItem("token");
      if (!token) throw new Error("Token not found");
      
      const response = await axios.get(
        `${config.baseURL}/posts-notification`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      console.log('API Response:', response.data); // Debugging line

      if (response.data.success) {
        // Convert the notifications object to an array
        const notificationsArray = Object.values(response.data.notifications || {});
        setNotifications(notificationsArray); // Set state with array of notifications
      } else {
        console.error("Error fetching notifications:", response.data.error);
      }
    } catch (error) {
      console.error("Error fetching notifications:", error);
    } finally {
      setLoading(false); // Set loading to false after API call
    }
  };

  fetchNotifications();
}, []);




const fetchUserLists = async () => {
  try {
    const token = localStorage.getItem('token');
    const url = `${config.baseURL}/get-users-list`;
    const response = await fetch(url, {
      headers: {
        'Authorization': `Bearer ${token}`
      }
    });
    const data = await response.json();

    if (data.success) {
      setUserLists(data.data);

      // Create a set of list IDs where the user is already present
      const initialCheckedLists = new Set(
        data.data
          .filter(list => list.users.some(user => user.id === showSaveToListModal.userId))
          .map(list => list.id)
      );

      setCheckedLists(initialCheckedLists);
    } else {
      setUserLists([]);
      setCheckedLists(new Set()); 
    }
  } catch (error) {
    console.error('Error fetching user lists:', error);
    setUserLists([]);
    setCheckedLists(new Set()); 
  }
};


useEffect(() => {
  if (showSaveToListModal.visible) {
    fetchUserLists();
  }
}, [showSaveToListModal.visible]);


// Handle the checkbox change (add/remove user from list)
const handleCheckboxChange = async (listId, userId, isChecked) => {
  const url = `${config.baseURL}/${isChecked ? 'add-user-to-list' : 'remove-user-from-list'}`;
  const params = new URLSearchParams();
  params.append('user_list_id', listId);
  params.append('listed_user_id', userId);

  try {
    const token = localStorage.getItem('token');
    await axios.post(url, params, {
      headers: {
        'Authorization': `Bearer ${token}`
      }
    });

    // Update the state based on whether the user was added or removed
    setCheckedLists(prevCheckedLists => {
      const updatedCheckedLists = new Set(prevCheckedLists);
      if (isChecked) {
        updatedCheckedLists.add(listId);
      } else {
        updatedCheckedLists.delete(listId);
      }
      return updatedCheckedLists;
    });
  } catch (error) {
    console.error('Error updating user list:', error);
  }
};

  const handleShowSaveToListModal = (userId) => {
    console.log("Show Save to List Modal for userId:", userId);
    setShowSaveToListModal({ visible: true, userId });
  };
  const handleSaveToListClick = (userId) => {
    setShowSaveToListModal({ visible: true, userId });
  };

  const handleCreateListClick = () => {
    setShowCreateListModal(true); // Show "Create New List" popup
    setShowSaveToListModal(false); // Optionally hide "Save to List" popup
  };

  const handleCloseModal = () => {
    setShowSaveToListModal({ visible: false, userId: null });
    setShowCreateListModal(false);
  };

  useEffect(() => {
    // Initialize the checked state based on userLists if needed
  }, [userLists]);

  const handleCreateListSubmit = async (e) => {
    e.preventDefault();
    try {
      if (listName.trim() === "") {
        setErrorMessage("List name cannot be empty");
        return;
      }
      if (listName.length > 64) {
        setErrorMessage("List name cannot exceed 64 characters");
        return;
      }

      const token = localStorage.getItem("token");
      if (!token) throw new Error("Token not found");
      const response = await fetch(`${config.baseURL}/create-user-list`, {
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/x-www-form-urlencoded",
        },
        body: new URLSearchParams({ title: listName }),
      });

      const data = await response.json(); 
      if (data.success) {
        setApiResponseMessage("List created successfully!");
        setShowCreateListModal(false);
        setListName("");
        setWordCount(0);

        // Fetch the updated user lists
        fetchUserLists();
      } else {
        setApiResponseMessage("Failed to create list");
      }
    } catch (error) {
      setApiResponseMessage("Error creating list");
    }
  };

    const getInitials = (name) => {
    const nameParts = name.split(' ');
    if (nameParts.length === 1) return nameParts[0][0].toUpperCase();
    return (nameParts[0][0] + nameParts[1][0]).toUpperCase();
  };

  return (
    <>
      
      <div className="notification_user_lists">
              {loading ? (
                <div className="load_more text-center">
                  <img className="loading_icon top_loader_space" src={loaderIcon} alt="Loading..." />
                </div>
              ) : notifications.length > 0 ? (
                notifications.map((notification) => (
                  <div className="wrap_notification" key={notification.user_id}>
                    <div className="notification_avatar">
                      <Link to={`/${notification.username}`}>
                        {notification.profile ? (
                          <img src={notification.profile} alt="Person Image" />
                        ) : (
                          <div className="after_image_not_avilable">
                            {getInitials(notification.name)}
                          </div>
                        )}
                        <span>
                          {notification.type === "SubscribeNotification" && (
                            <img src={subscriptions_user} alt="subscription" />
                          )}
                          {notification.type === "TipNotification" && (
                            <img src={TipNotification} alt="Tip Notification" />
                          )}
                          {notification.type === "CommentLikeNotification" && (
                            <img src={CommentLikeNotification} alt="Comment Like" />
                          )}
                          {notification.type === "CommentReplyNotification" && (
                            <img src={CommentLikeNotification} alt="Comment Reply" />
                          )}
                          {notification.type === "PostCommentNotification" && (
                            <img src={CommentLikeNotification} alt="Post Comment Notification" />
                          )}
                          {notification.type === "PostLikeNotification" && (
                            <img src={like_notification} alt="Post Like" />
                          )}
                          {notification.type === "PostMentionNotification" && (
                            <img src={PostMentionNotification} alt="Post Mention" />
                          )}
                          {notification.type === "PostPurchasedNotification" && (
                            <img src={PostPurchasedNotification} alt="Post Purchased Notification" />
                          )}
                        </span>
                      </Link>
                    </div>
                    <div className="notification_avatar_content">
                      <div className="profile_date_notification">
                        <Link className="name_user" to={`/${notification.username}`}>
                          {notification.name}
                        </Link>
                        <img src={verified} alt="" />
                        <Link className="gray_link_color" to={`/${notification.username}`}>
                          @{notification.username}
                        </Link>
                      </div>
                       {notification.is_in_list ? (
                        <CollectionUserListNotification 
                          user={notification.username} 
                          userId={notification.user_id} 
                          UserlistId={notification.list_id} 
                          UserlistName={notification.list_name} 
                        />
                      ) : (
                        <CollectionCreateListNotification 
                          user={notification.username} 
                          userId={notification.user_id}
                           UserlistId={notification.list_id} 
                          UserlistName={notification.list_name}  
                        />
                      )}
                      <div className="notification_content">
                        {notification.message}
                        {notification.post_id && notification.username && (
                          <Link to={`/${notification.post_id}/${notification.username}`} className="check_it_out_link">
                            Check it out
                          </Link>
                        )}
                      </div>
                      <div className="notification_date">
                        {notification.created_at}
                      </div>
                    </div>
                  </div>
                ))
              ) : (
                <div className="nothing-found-message">
                  No notifications currently!
                </div>
              )}
            </div>



      {/* Save to List Modal */}
      {showSaveToListModal.visible && (
        <>
          <div className="modal-overlay-dark" onClick={handleCloseModal}></div>
          <div
            className="modal restoreAccessModalAccess save_list_popup fade show"
            style={{ display: "block" }}
            tabIndex="-1"
            role="dialog"
            aria-labelledby="saveToListModalLabel"
            aria-hidden="true"
          >
            <div className="modal-dialog modal-dialog-centered" role="document">
              <div className="modal-content">
                <div className="modal-header">
                  <h5 className="modal-title" id="saveToListModalLabel">
                    SAVE TO LIST
                  </h5>
                </div>
                <div className="modal-body">
                  {userLists && userLists.length === 0 ? (
                    <div className="no_list_message">Nothing found</div>
                  ) : (
                    <ul>
                      {userLists.map((list) => (
                        <li key={list.id}>
                          <div className="list_wrap_popup">
                            <div className="m-checkbox-row checkbox_table">
                              <input
                              type="checkbox"
                              checked={checkedLists.has(list.id)}
                              onChange={(e) => {
                                const userId = showSaveToListModal.userId;
                                handleCheckboxChange(list.id, userId, e.target.checked);
                              }}
                              id={`checkbox-${list.id}`}
                            />
                              <label
                                htmlFor={`checkbox-${list.id}`}
                                className="g-input__wrapper"
                              ></label>
                            </div>
                            <div className="list_popup">
                              <div className="list_popup_left">
                                <span>{list.title}</span>
                                <small>{list.user_count} user</small>
                              </div>
                              <div className="list_popup_right">
                                {list.users && list.users.length > 0 ? (
                                    list.users.map(user => (
                                      user.profile_image && (
                                        <img
                                          key={user.id}
                                          src={user.profile_image}
                                          alt={user.title}
                                          style={{ width: '40px', height: '40px', borderRadius: '50%' }}
                                        />
                                      )
                                    ))
                                  ) : (
                                    list.profile_image && (
                                      <img
                                        src={list.profile_image}
                                        alt={list.title}
                                        style={{ width: '40px', height: '40px', borderRadius: '50%' }}
                                      />
                                    )
                                  )}
                              </div>
                            </div>
                          </div>
                        </li>
                      ))}
                    </ul>
                  )}
                </div>
                <div className="modal-footer">
                  <button
                    type="button"
                    className="btn btn-primary cancel_btn"
                    onClick={handleCreateListClick}
                  >
                    <svg
                      enableBackground="new 0 0 50 50"
                      height="20px"
                      id="Layer_1"
                      version="1.1"
                      viewBox="0 0 50 50"
                      width="20px"
                      xmlSpace="preserve"
                      xmlns="http://www.w3.org/2000/svg"
                      xmlnsXlink="http://www.w3.org/1999/xlink"
                    >
                      <rect fill="none" height={20} width={20} />
                      <line
                        fill="none"
                        stroke="#00aff0"
                        strokeMiterlimit={10}
                        strokeWidth={4}
                        x1={9}
                        x2={41}
                        y1={25}
                        y2={25}
                      />
                      <line
                        fill="none"
                        stroke="#00aff0"
                        strokeMiterlimit={10}
                        strokeWidth={4}
                        x1={25}
                        x2={25}
                        y1={9}
                        y2={41}
                      />
                    </svg>
                    New list
                  </button>
                  <button
                    type="button"
                    className="btn btn-secondary cancel_btn"
                    onClick={handleCloseModal}
                  >
                    Close
                  </button>
                </div>
              </div>
            </div>
          </div>
        </>
      )}

      {/* Create New List Modal */}
      {showCreateListModal && (
        <>
          <div className="modal-overlay-dark" onClick={handleCloseModal}></div>
          <div
            id="restoreAccessForm"
            className="modal restoreAccessModalAccess fade show"
            style={{ display: "block" }}
            tabIndex="-1"
            role="dialog"
            aria-labelledby="createListModalLabel"
            aria-hidden="true"
          >
            <div className="modal-dialog modal-dialog-centered" role="document">
              <div className="modal-content">
                <div className="modal-header">
                  <h5 className="modal-title" id="createListModalLabel">
                    CREATE NEW LIST
                  </h5>
                </div>
                <div className="modal-body">
                  <form onSubmit={handleCreateListSubmit}>
                    <div className="position_relative">
                      <input
                        type="text"
                        className="form-control"
                        value={listName}
                        onChange={(e) => {
                          setListName(e.target.value);
                          setWordCount(e.target.value.length);
                        }}
                        maxLength="64"
                        placeholder=""
                      />
                      <label htmlFor="listname" className="placeholder-label">
                        List Name
                      </label>
                      <div className="word_count">{wordCount} / 64</div>
                    </div>
                    <div className="modal-footer">
                      <button
                        type="button"
                        className="btn btn-primary send_btn"
                        onClick={() => setShowCreateListModal(false)}
                      >
                        Cancel
                      </button>
                      <button
                        type="submit"
                        className="btn btn-primary send_btn"
                      >
                        Save
                      </button>
                    </div>
                  </form>
                  {apiResponseMessage && <p>{apiResponseMessage}</p>}
                </div>
              </div>
            </div>
          </div>
        </>
      )}
    </>
  );
};

export default PillsPostNotification;
